







































import { CommonModule } from '@/store/modules/common'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getDeductionGoldBeanList } from '@/api'
import moment from 'moment'
@Component({
  name: 'GoldenbeanHarvest',
  filters: {
    dateFormat: (value: any, pattern: any) => {
      return moment(value).format(pattern)
    }
  }
})
export default class GoldenbeanHarvest extends Vue {
  [x: string]: any
  list: any = []
  // 当前语言
  @Prop({
    type: String,
    default: 'ug'
  })
  language!: string
  emptyImage = require('@/assets/Empty_NoData.png')

  created() {
    this.getDeductionGoldBeanList()
  }

  async getDeductionGoldBeanList() {
    const { data, code } = await getDeductionGoldBeanList({
      pageNum: 1,
      pageSize: 999,
      startTime: new Date().getFullYear() + '-01-01 00:00:00',
      endTime: new Date().getFullYear() + '-12-31 23:59:59',
      userId: CommonModule.userId || '431319'
    })
    if (code == 1001) {
      this.list = data.list
      console.log(this.list, '///')
    }
  }
}
